;(function () {
  'use strict'

  /**
   * Expenseclaim Module
   *
   */

  angular
    .module('expenseclaim', ['ngResource', 'settings', 'ngRoute'])
    .config(['$routeProvider', function ($routeProvider) {
      $routeProvider
        .when(CONFIG.url.expenseclaim.all(), {
          controller: 'ExpenseclaimCtrl',
          templateUrl: '/r/static/templates/expenseclaim/list.html',
        })
        .when(CONFIG.url.expenseclaim.archive(), {
          controller: 'ExpenseclaimArchiveCtrl',
          templateUrl: '/r/static/templates/expenseclaim/archive.html',
        })
        .when(CONFIG.url.expenseclaim.view(), {
          controller: 'ExpenseclaimViewCtrl',
          templateUrl: '/r/static/templates/expenseclaim/view.html',
        })
        .when(CONFIG.url.expenseclaim.edit(), {
          controller: 'ExpenseclaimEditCtrl',
          templateUrl: '/r/static/templates/expenseclaim/single.html',
        })
    }])
    .factory('Expenseclaim', ['$resource', function ($resource) {
      var Expenseclaim = $resource(
        CONFIG.api('expenseclaim'),
        {},
        {
          query: {method: 'GET', isArray: false},
          view: {method: 'GET', isArray: false, params: {id: 'view'}},
          updateStatus: {method: 'POST', params: {id: 'update_status'}},
          addComment: {method: 'POST', params: {id: 'add_comment'}},
          markPaid: {method: 'POST', params: {id: 'mark_paid'}},
        },
      )
      return Expenseclaim
    }])

  function getUpgradeUrl(settings) {
    return settings.a4_cms_version_ == 'perlcms' ? '/sys/vtp/index.dip.html#!/upgrade' : '/@admin/upgrade'
  }

  angular.module('expenseclaim').controller('ExpenseclaimDashboardCtrl', ['$scope', 'Expenseclaim', function ($scope, Expenseclaim) {
    Expenseclaim.query(
      {id: 'all'},
      // success handler
      function (data) {
        if (data.pending.length || data.accepted.length) {
          $scope.show = 'waiting'
          var sum = {
            pending: 0,
            accepted: 0,
          }
          var count = {
            pending: 0,
            accepted: 0,
          }
          $.each(['pending', 'accepted'], function (i, status) {
            $.each(data[status], function (j, claim) {
              sum[status] += +claim.amount
              count[status] += +claim.count
            })
          })
          $scope.pending_count = count.pending
          $scope.pending_total = Math.round(sum.pending * 100) / 100
          $scope.accepted_count = count.accepted
          $scope.accepted_total = Math.round(sum.accepted * 100) / 100
        } else if (data.accepted.length || data.archive_count) {
          $scope.show = 'allclear'
        } else {
          $scope.show = 'trynow'
        }
        a4.loaded($scope)
      },
      // error handler
      a4.restErrorFactory($scope),
    )
  }])

  angular.module('expenseclaim').service('Helper', function (/* Expenseclaim */) {
    // Helper function to update the columns as we throw items back to 'pending', from 'accepted' or 'rejected'
    this.update_columns = function ($scope, from_column, claim_id, person_id, person_account_number) {
      var amount = 0
      var date
      var person_name

      // Update the "from" column ('accepted' or 'rejected')
      $.each($scope[from_column], function (claim_idx, claim) {
        if (claim && claim.person_id === person_id && claim.person_account_number === person_account_number) {
          person_name = claim.person_name
          $.each(claim.items, function (item_idx, item) {
            if (item.id === claim_id) {
              amount = item.amount
              date = item.date
              claim.items.splice(item_idx, 1)
              claim.amount = (parseFloat(claim.amount) - parseFloat(amount)).toFixed(2)
              claim.count--
              claim.date_min = null
              claim.date_max = null
              if (claim.count === 0) {
                $scope[from_column].splice(claim_idx, 1)
              }
              return false
            }
          })
        }
      })
      $.each($scope[from_column], function (claim_idx, claim) {
        if (claim && claim.person_id === person_id && claim.person_account_number === person_account_number) {
          $.each(claim.items, function (item_idx, item) {
            if (claim.date_min === null || item.date < claim.date_min) {
              claim.date_min = item.date
            }
            if (claim.date_max === null || item.date > claim.date_max) {
              claim.date_max = item.date
            }
          })
        }
      })

      if (from_column === 'accepted') {
        // If we are moving an item from 'pending' to 'accepted', we need
        // to update the 'pending' column also as they are on the same page.
        var pending_column_updated = false
        $.each($scope.pending, function (claim_idx, claim) {
          if (claim.person_id === person_id && claim.person_account_number === person_account_number) {
            claim.count++
            claim.amount = (parseFloat(claim.amount) + parseFloat(amount)).toFixed(2)
            if (date > claim.date_max) {
              claim.date_max = date
            } else if (date < claim.date_min) {
              claim.date_min = date
            }
            pending_column_updated = true
            return false
          }
        })
        if (!pending_column_updated) {
          $scope.pending.push({
            amount: amount,
            count: 1,
            date_min: date,
            date_max: date,
            person_account_number: person_account_number,
            person_id: person_id,
            person_name: person_name,
          })
        }
      }
    }
  })

  /* Controllers */

  angular
    .module('expenseclaim')
    .controller('ExpenseclaimCtrl', ['$scope', '$location', '$timeout', '$rootScope', 'Expenseclaim', 'Helper', 'Settings', function ($scope, $location, $timeout, $rootScope, Expenseclaim, Helper, Settings) {
      if ($location.path() === CONFIG.url.expenseclaim.all()) {
        $scope.utils.setPageTitle(_('breadcrumb_expense_claims'))
        $scope.utils.setPageID('expenseclaim')
      }

      Settings.get({}, function (settings) {
        $scope.upgrade_url = getUpgradeUrl(settings)
      })

      getExpenseclaim()

      function getExpenseclaim() {
        Expenseclaim.query(
          {
            id: 'all',
          },
          // success handler
          function (data) {
            $scope.pending = data.pending
            $scope.accepted = data.accepted
            $scope.archive_count = data.archive_count
            $scope.accepted_this_year = data.accepted_this_year
            // welcome graph
            if (
              $rootScope.session &&
              (!$rootScope.session.get_persistent_data('RegClaimHelp') ||
                $rootScope.session.get_persistent_data('RegClaimHelp') === '0')
            ) {
              $('#claim-intro-container').show()
              $scope.show_help = true
            } else {
              $scope.show_help = false
            }
            a4.loaded($scope)
          },
          // error handler
          a4.restErrorFactory($scope),
        )

        $scope.hideIntro = function () {
          $('.help-btn').css('display', 'none')
          $('#claim-intro-container').slideUp(300)
          $rootScope.session.set_persistent_data('RegClaimHelp', '1')
          $scope.show_help = false
        }

        $scope.showIntro = function () {
          $('#claim-intro-container').slideDown(300, function () {
            $('.help-btn').css('display', 'inline')
          })
          $rootScope.session.set_persistent_data('RegClaimHelp', '0')
          $scope.show_help = true
        }

        $scope.view = function (person_id, account_number) {
          $location.path(CONFIG.url.expenseclaim.view(person_id, account_number))
        }

        $scope.markPaid = function (person_id, account_number) {
          Expenseclaim.markPaid(
            {
              person_id: person_id,
              account_number: account_number,
            },
            function (/* data */) {
              $.each($scope.accepted, function (claim_idx, claim) {
                if (claim && claim.person_id === person_id && claim.person_account_number === account_number) {
                  $scope.accepted.splice(claim_idx, 1)
                  return false
                }
              })
              $scope.archive_count += 1
              $scope.notify.instant($rootScope, _('claim_batch_marked_paid'))
              a4.loaded($scope)
            },
            // error handler
            a4.restErrorFactory($scope),
          )
        }

        $scope.selectBarcode = function () {
          $('#virtual-barcode').select()
        }

        $scope.removeItem = function (claim_id, person_id, person_account_number) {
          Expenseclaim.updateStatus(
            {
              id: claim_id,
              status: 'pending',
            },
            // success handler
            function (/* data */) {
              Helper.update_columns($scope, 'accepted', claim_id, person_id, person_account_number)
              $scope.notify.instant($rootScope, _('claim_moved_back_to_pending'))
            },
            // error handler
            a4.restErrorFactory($scope, claim_id),
          )
        }
      }
    }])

  angular
    .module('expenseclaim')
    .controller('ExpenseclaimArchiveCtrl', ['$scope', '$location', '$timeout', '$rootScope', 'Expenseclaim', 'Helper', function ($scope, $location, $timeout, $rootScope, Expenseclaim, Helper) {
      $scope.utils.setPageTitle(_('breadcrumb_expense_claims'))
      $scope.utils.setPageID('expenseclaim')

      getExpenseclaim()

      function getExpenseclaim() {
        Expenseclaim.query(
          {
            id: 'all',
            archive: true,
          },
          // success handler
          function (data) {
            $scope.rejected = data.rejected
            $scope.paid = data.paid
            a4.loaded($scope)
          },
          // error handler
          a4.restErrorFactory($scope),
        )
      }

      $scope.removeItem = function (claim_id, person_id, person_account_number) {
        Expenseclaim.updateStatus(
          {
            id: claim_id,
            status: 'pending',
          },
          // success handler
          function (/* data */) {
            Helper.update_columns($scope, 'rejected', claim_id, person_id, person_account_number)
            $scope.notify.instant($rootScope, _('claim_moved_back_to_pending'))
          },
          // error handler
          a4.restErrorFactory($scope, claim_id),
        )
      }
    }])

  angular
    .module('expenseclaim')
    .controller(
      'ExpenseclaimViewCtrl',
      ['$scope', '$routeParams', '$location', '$timeout', 'Expenseclaim', '$route', '$rootScope', '$modal', 'Settings', function ($scope, $routeParams, $location, $timeout, Expenseclaim, $route, $rootScope, $modal, Settings) {
        $scope.utils.setPageID('expenseclaim')

        $scope.show_comments = {}

        Settings.get({}, function (settings) {
          $scope.upgrade_url = getUpgradeUrl(settings)
        })

        getExpenseclaims()

        function getExpenseclaims() {
          Expenseclaim.view(
            {person_id: $routeParams.person_id, person_account_number: $routeParams.person_account_number},
            // success handler
            function (data) {
              $scope.claims = data.rows.map(function (claim) {
                $.each(['date', 'per_diem_end_date'], function (didx, d) {
                  if (claim[d]) {
                    var date = new Date(Date.parse(claim[d]))
                    claim[d + '_date_'] = [
                      date.getFullYear(),
                      1 + date.getMonth() >= 10 ? 1 + date.getMonth() : `0${1 + date.getMonth()}`,
                      date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`,
                    ].join('-')
                    claim[d + '_hh_'] = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours()
                    claim[d + '_mm_'] = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes()
                  }
                })
                return new Expenseclaim(claim)
              })
              $scope.range_hh = Array.apply(null, {length: 24}).map(function (a, b) {
                return b >= 10 ? b : '0' + b
              })
              $scope.range_mm = Array.apply(null, {length: 60}).map(function (a, b) {
                return b >= 10 ? b : '0' + b
              })
              $scope.utils.setPageTitle(_('claim_expense_claim') + ' (' + data.rows[0].person_name + ')')
              $scope.accepted_this_year = data.accepted_this_year
              a4.loaded($scope)
            },
            a4.restErrorFactory($scope),
          )
        }

        function set_processed_claim(id) {
          $.each($scope.claims, function (claim_idx, claim) {
            if (claim && claim.id === id) {
              $scope.claim = $scope.claims[claim_idx]
              $scope.$watch('claim.km_kilometers + claim.km_a_price', function () {
                if (
                  String($scope.claim.km_kilometers).match(/^\d+$/) &&
                  String($scope.claim.km_a_price).match(/^\d+\.\d+$/)
                ) {
                  $scope.claim.amount = ($scope.claim.km_kilometers * $scope.claim.km_a_price).toFixed(2)
                }
              })
              return false
            }
          })
        }

        $scope.updateStatus = function (id, status) {
          if (status === 'rejected' && !$scope.comment) {
            $scope.show_error = true
            return
          }
          Expenseclaim.updateStatus(
            {
              id: id,
              status: status,
              comment: $scope.comment,
            },
            // success handler
            function (/* data */) {
              $scope.comment = ''
              var still_pending = 0
              $.each($scope.claims, function (idx, c) {
                if (c.id === id) {
                  c.status = status
                }
                if (c.status === 'pending') {
                  still_pending++
                }
              })
              var notify =
                status === 'accepted' ? _('HTML_notification_claim_accepted') : _('HTML_notification_claim_rejected')
              if (still_pending) {
                $scope.notify.instant($rootScope, notify)
                if (status === 'rejected') {
                  $scope.$modal('hide')
                }
              } else {
                $scope.notify.set($scope, notify)
                $location.path(CONFIG.url.expenseclaim.all())
              }
            },
            // error handler
            a4.restErrorFactory($scope, id),
          )
        }

        $scope.save = a4.saveFactory($scope, function (id) {
          set_processed_claim(id)

          // Accept comma as decimal separator
          $scope.claim.amount = $scope.claim.amount.replace(',', '.')

          if ($scope.claim.expense_type === 'per_diem') {
            ;['date', 'per_diem_end_date'].forEach(function (f) {
              var dateParts = $scope.claim[f + '_date_'].split('-')
              var d = new Date(
                dateParts[0],
                dateParts[1] - 1,
                dateParts[2],
                $scope.claim[f + '_hh_'],
                $scope.claim[f + '_mm_'],
              )
              $scope.claim[f] = d.toISOString()
            })
          } else {
            $scope.claim.date = $scope.claim.date_date_ + 'T00:00:00'
          }
          $scope.claim.$save(
            {id: $scope.claim.id},
            // success handler
            function () {
              $scope.claim = null
              $scope.notify.set($scope, _('HTML_notification_claim_edited'))
              $route.reload()
            },
            // error handler
            a4.restErrorFactory($scope, null, true),
          )
        })

        $scope.addComment = function (id) {
          Expenseclaim.addComment(
            {
              id: id,
              comment: $scope.new_comment,
            },
            // succcess handler
            function (data) {
              $scope.new_comment = ''
              data.date += 'Z'
              $.each($scope.claims, function (idx, c) {
                if (c.id === id) {
                  c.comments.push(data)
                  return false
                }
              })
            },
            // error handler
            a4.restErrorFactory($scope, id),
          )
        }

        $scope.openModal = function (template, id) {
          set_processed_claim(id)
          $modal({
            template: '/r/static/templates/expenseclaim/modal-' + template + '.html',
            persist: true,
            show: true,
            backdrop: 'static',
            scope: $scope,
          }).then(function () {
            $timeout(function () {
              $('#' + template + '-' + id).focus()
            }, 700)
          })
        }
      }],
    )

  angular
    .module('expenseclaim')
    .controller('ExpenseclaimEditCtrl', ['$scope', '$routeParams', '$location', 'Expenseclaim', function ($scope, $routeParams, $location, Expenseclaim) {
      $scope.utils.setPageID('expenseclaim')

      getExpenseclaim()

      function getExpenseclaim() {
        Expenseclaim.get(
          {id: $routeParams.id},
          // success handler
          function (data) {
            $scope.claim = data
            $scope.utils.setPageTitle(_('claim_expense_claim') + ' (' + data.person_name + ')')
            a4.loaded($scope)
          },
          a4.restErrorFactory($scope),
        )
      }

      $scope.cancel = function () {
        $location.path(CONFIG.url.expenseclaim.all())
      }

      $scope.updateStatus = function (status, id) {
        Expenseclaim.updateStatus(
          {
            id: id,
            status: status,
          },
          // success handler
          function (/* data */) {
            $location.path(CONFIG.url.expenseclaim.all())
          },
          // error handler
          a4.restErrorFactory($scope, id),
        )
      }
    }])
})()
